// Filters — collapsible faceted sidebar.

import { useState } from "react";
import { cn } from "@/lib/cn";

export interface FacetOption {
  value: string;
  label: string;
  count?: number;
}

export interface Facet {
  key: string;
  label: string;
  options: FacetOption[];
}

export interface FiltersProps {
  facets: Facet[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
  onClear?: () => void;
}

export function Filters({ facets, values, onChange, onClear }: FiltersProps) {
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});
  return (
    <aside className="lex-facets" aria-label="Filters">
      {onClear && Object.keys(values).length > 0 ? (
        <button
          type="button"
          className="lex-filterbar__clear"
          onClick={onClear}
          style={{ alignSelf: "flex-start" }}
        >
          Clear filters
        </button>
      ) : null}
      {facets.map(facet => {
        const isCollapsed = collapsed[facet.key];
        return (
          <section key={facet.key} className="lex-facets__group">
            <button
              type="button"
              className="lex-facets__heading"
              onClick={() => setCollapsed(c => ({ ...c, [facet.key]: !c[facet.key] }))}
              style={{ background: "transparent", border: "none", textAlign: "left", cursor: "pointer", width: "100%" }}
              aria-expanded={!isCollapsed}
            >
              {facet.label}
            </button>
            {!isCollapsed && facet.options.map(opt => {
              const active = values[facet.key] === opt.value;
              return (
                <button
                  key={opt.value}
                  type="button"
                  className={cn("lex-facets__row", active && "lex-facets__row--active")}
                  onClick={() => onChange(facet.key, active ? "" : opt.value)}
                  aria-pressed={active}
                >
                  <span>{opt.label}</span>
                  {opt.count != null ? <span className="lex-facets__count">{opt.count}</span> : null}
                </button>
              );
            })}
          </section>
        );
      })}
    </aside>
  );
}

export default Filters;
